export enum SignInActions {
  RESOLVE_ACCOUNT_TYPE = 'resolve_account_type',
  AUTHENTICATE = 'authenticate',
}
